"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _server = require("react-dom/server");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fuseColours = _interopRequireDefault(require("@tvg/fuse-colours"));
var _HideImage = _interopRequireDefault(require("@tvg/fuse-icons/lib/HideImage"));
var _excluded = ["alt", "isAltReal"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var propTypes = {
  alt: _propTypes["default"].string.isRequired,
  isAltReal: _propTypes["default"].bool
};
var defaultProps = {
  isAltReal: false
};
var StyledDefaultImg = _styledComponents["default"].img.withConfig({
  displayName: "default-image__StyledDefaultImg",
  componentId: "sc-3srboi-0"
})(["object-fit:cover;max-width:100%;min-width:100%;"]);
var MissingImage = _styledComponents["default"].span.withConfig({
  displayName: "default-image__MissingImage",
  componentId: "sc-3srboi-1"
})(["display:flex;aspect-ratio:3 / 4;@supports not (aspect-ratio:3 / 4){&:before{content:'';padding-top:calc(4 / 3 * 100%);}}align-items:stretch;justify-content:center;position:relative;&:after{content:'';width:40%;aspect-ratio:1 / 1;@supports not (aspect-ratio:1 / 1){height:30%;}display:block;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);background:", ";opacity:0.2;}"], "url('data:image/svg+xml, ".concat(encodeURIComponent((0, _server.renderToStaticMarkup)( /*#__PURE__*/_react["default"].createElement(_HideImage["default"], null))), "')"));
function DefaultImage(_ref) {
  var alt = _ref.alt,
    isAltReal = _ref.isAltReal,
    props = _objectWithoutProperties(_ref, _excluded);
  var src = "data:image/svg+xml, ".concat(encodeURIComponent("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1 1\">\n            <path d=\"M0 0h1v1H0\" fill=\"".concat(_fuseColours["default"].global.grey400, "\"/>\n        </svg>")));
  return /*#__PURE__*/_react["default"].createElement(MissingImage, props, /*#__PURE__*/_react["default"].createElement(StyledDefaultImg, {
    src: src,
    alt: alt,
    "aria-hidden": isAltReal ? undefined : 'true'
  }));
}
DefaultImage.propTypes = propTypes;
DefaultImage.defaultProps = defaultProps;
var _default = exports["default"] = DefaultImage;